import { STATUSES } from 'constants/common';
import { ENV_DEVELOPMENT } from 'constants/env';
import { DEFAULT_LESSON_LOCALE } from 'constants/lessonLocale';

export const isLessonSaveVisible = ({
  status,
  activeLocale,
}: {
  status?: string;
  activeLocale?: string;
}): boolean => {
  if (ENV_DEVELOPMENT) {
    return true;
  }

  if (!status || status === STATUSES.DRAFT) {
    return true;
  }

  return activeLocale === DEFAULT_LESSON_LOCALE;
};
